import styled from "@emotion/styled";

export const StyledTileLabel = styled.div`
  position: absolute;
  top: 5px;
  left: 8px;
  z-index: 2;
  font-size: 0.8rem;
  color: #000;
  display: block;
  white-space: nowrap;
  background: #fff;
  padding: 4px 8px;
  border-radius: 3px;
  border-bottom-left-radius: 0;
  box-shadow: 0 0 10px rgba(0,0,0,0.6);

  &::after {
    top: 100%;
    left: 0;
    position: absolute;
    display: block;
    content: "";
    color: #fff;
    border: 4px solid;
    border-right-color: transparent;
    border-bottom-color: transparent;
  }
`;

export const StyledTile = styled.div`
  position: absolute;
  height: 100%;

  &::before, &::after {
    content: "";
    display: inline-block;
    position: absolute;
    height: 100%;
    width: 0;
    border-style: dashed;
  }
  
  &::before { 
    border-left: 2px;
    left: 0; 
  }

  &::after {
    border-right: 2px;
    visibility: hidden;
    right: 0;
  }

  &:last-of-type::after {
    visibility: visible;
  }
`;